import { Button } from '#/components/ui/button';
import { Input } from '#/components/ui/input';
import formatEther from '#/utils/formatEther';
import { parseEther } from 'ethers/lib/utils';
import { Minus, Plus } from 'lucide-react';
import React, { ChangeEvent, useCallback } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

const StakingValidatorsInput = React.forwardRef<
  HTMLInputElement,
  ControllerRenderProps
>(({ onChange, onBlur, value, name }, ref) => {
  const internalSetValue = useCallback(
    async (valueAsNumber: number) => {
      if (isNaN(valueAsNumber)) {
        onChange(null);
      } else {
        if (valueAsNumber >= 0 && valueAsNumber < Number.MAX_SAFE_INTEGER) {
          onChange(valueAsNumber);
        }
      }
    },
    [onChange]
  );
  const onIncrease = useCallback(async () => {
    const valueAsNumber = parseInt(value);
    internalSetValue((!isNaN(valueAsNumber) ? valueAsNumber : 0) + 1);
  }, [internalSetValue, value]);
  const onDecrease = useCallback(async () => {
    const valueAsNumber = parseInt(value);
    internalSetValue((!isNaN(valueAsNumber) ? valueAsNumber : 0) - 1);
  }, [internalSetValue, value]);
  const onInputChange = useCallback(
    async (event: ChangeEvent) => {
      const valueAsNumber = (event.target as HTMLInputElement).valueAsNumber;
      internalSetValue(valueAsNumber);
    },
    [internalSetValue]
  );
  return (
    <div className="relative group">
      <Input
        type="number"
        className="h-16 text-2xl"
        name={name}
        value={value}
        onChange={onInputChange}
        onBlur={onBlur}
        ref={ref}
        // min={min}
        // max={max}
      />
      <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-2 justify-center items-center">
        <Button
          variant="secondary"
          type="button"
          className="px-0 w-10"
          onClick={onDecrease}
        >
          <Minus className="w-4 h-4" />
        </Button>
        <Button
          variant="secondary"
          type="button"
          className="px-0 w-10"
          onClick={onIncrease}
        >
          <Plus className="w-4 h-4" />
        </Button>
        <div
          className="shrink-0 min-w-48 bg-gray-800 rounded flex items-center justify-center p-2"
          tabIndex={-1}
        >
          <span className="text-white text-base font-bold font-mono">
            = {formatEther(parseEther('32').mul(value || 0))} ETH
          </span>
        </div>
      </div>
    </div>
  );
});
StakingValidatorsInput.displayName = 'StakingValidatorsInput';
export { StakingValidatorsInput };
